const adminUsersListConstantsAr = {
  totalMembers: 'مستخدم',
  deleteUserTitle: 'حذف المستخدم',
  deleteUserContent: 'هل أنت متأكد أنك تريد حذف هذا المستخدم من لوحة الإدارة؟',
  firstName: 'الإسم الأول',
  lastName: 'الإسم الأخير',
  email: 'البريد الإلكتروني',
  role: 'الوظيفة',
  userStatus: 'الحالة',
  adminUsersTitle: 'المستخدمين',
  activate: 'تفعيل',
  deactivate: 'تعطيل',
  inactive: 'غير فعال',
  active: 'فعال',
  admin: 'مدير',
  dataEntry: 'مدخل بيانات',
  noRole: 'غير محدد',
};

export default adminUsersListConstantsAr;
